import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { PreSignService } from '../../../shared/services/preSign.service';
import { HttpClient } from '@angular/common/http';
import { CaseService } from '../../../shared/services/case.service';

@Component({
  selector: 'guardian-upload-doc-dialog',
  templateUrl: './guardian-upload-doc-dialog.component.html',
  styleUrls: ['./guardian-upload-doc-dialog.component.scss'],
  providers: [PreSignService]
  
})
export class GuardianUploadDocDialogComponent implements OnInit {
  msg = '';
  uploadLoading = false;

  upload1=false;
  upload2=false;

  files: any = null;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<GuardianUploadDocDialogComponent>,
    private preSign: PreSignService,
    private caseService: CaseService
  ) { }
  ngOnInit() {
  }

  fileUpload(event) {
    // this makes sure they did not just back out of the file selector.
    if (event.target.files.length === 0 ) {
      return 0;
    }
    this.uploadLoading = true;
    this.uploadFile(event.target.files[0], 'GardianAdlitem_Reports');
  }

  fileUpload2(event) {
    // this makes sure they did not just back out of the file selector.
    if (event.target.files.length ===0 ) {
      return 0;
    }

    this.uploadLoading = true;
    

    this.uploadFile(event.target.files[0], 'GardianAdlitem_Fees');
  }


  uploadFile(file, name) {
    this.preSign
      .getPresign(this.data.org, this.data.case.id, name)
      .subscribe(result => {
        this.preSign.uploadFile(result, file).subscribe(result => {
          if (result === 200) {
            if(name ==='GardianAdlitem_Reports'){
              this.upload1 =true;
            }
            if(name ==='GardianAdlitem_Fees'){
              this.upload2 = true;
            }
            if(this.upload1 ==true && this.upload2 == true){
              let d = {
                status: 'SET_HEARING'
              };
              this.caseService.putCaseNew(this.data.org, this.data.case.id, d)
                .subscribe(result => {
                  this.dialogRef.close(true);
                });
            }
            this.uploadLoading = false;
          } else {

          }
        });
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/main/shared/dialog/guardian-upload-doc-dialog/guardian-upload-doc-dialog.component.ts